import {
    ConsolidationReportDestination,
    getConsolidationReportDestinations,
} from "@components/accounting/consolidationReports/consolidationReportDestinations";
import { ConsolidationReportContext } from "@components/accounting/consolidationReports/useConsolidationReportContext";
import {
    getDefaultEndDate,
    getDefaultStartDate,
} from "@components/accounting/useProfitLossInitialDates";

const NAV_BOOKMARK_IDS: ReadonlyArray<ConsolidationReportDestination["id"]> = [
    "profitLoss",
    "balanceSheet",
];

/**
 * Left-nav consolidation-group bookmarks: P&L and Balance Sheet only.
 * Elimination-only reports stay out of the left-nav bookmarks.
 */
export function getConsolidationGroupNavBookmarks({
    context,
    startDate = getDefaultStartDate(),
    endDate = getDefaultEndDate(),
}: {
    context: ConsolidationReportContext;
    startDate?: Date;
    endDate?: Date;
}): readonly ConsolidationReportDestination[] {
    const destinations = getConsolidationReportDestinations({
        context,
        startDate,
        endDate,
    });

    return destinations.filter((destination) =>
        NAV_BOOKMARK_IDS.some((id) => id === destination.id),
    );
}
